import { ReactNode, useEffect, useState } from "react";
import { Permission } from "v2/domain/common/entities/ManagerPermission/ManagerPermission";
import CenterLoader from "v2/ui/components/CenterLoader";
import useFindManagerPermissions from "v2/ui/hooks/common/useFindManagerPermissions/useFindManagerPermissions";
import { redirect } from "./Routes";

export default function ProtectedRoute({
  children,
  permissions,
}: {
  children: ReactNode;
  permissions: Permission[];
}) {
  const { data: loggedManagerPermissions, isFetching } =
    useFindManagerPermissions();

  const [shouldRender, setShouldRender] = useState<boolean>(false);

  useEffect(() => {
    if (loggedManagerPermissions) {
      const hasPermission = permissions.every((permission) =>
        loggedManagerPermissions.hasPermission(permission)
      );

      if (!hasPermission) {
        redirect("/v2");
      } else {
        setShouldRender(true);
      }
    }
  }, [loggedManagerPermissions, permissions]);

  if (isFetching || !shouldRender) {
    return <CenterLoader />;
  }

  return <>{children}</>;
}
